import MyProfile from "../../../components/dashboard/MyProfile";
import SidebarMenu from "../../../components/dashboard/SidebarMenu";
import Header2 from "../../../components/headers/Header2";
import React from "react";

import MetaComponent from "../../../components/common/MetaComponent";
const metadata = {
  title: "My Profile || Homelengo - Real Estate Reactjs Template",
  description: "Homelengo - Real Estate Reactjs Template",
};
export default function MyProfilePage() {
  return (
    <>
      <MetaComponent meta={metadata} />
      <div className="layout-wrap">
        <Header2 />
        <SidebarMenu />
        <MyProfile />
        <div className="overlay-dashboard" />
      </div>
    </>
  );
}
